import { gql } from "@apollo/client";

import { MESSAGE_INFO } from "../fragments";

export const SEND_MESSAGE = gql`
  mutation sendMessage($input: MessageInput!) {
    sendMessage(input: $input) {
      id
      isAdmin
      isGreet
      chatRoom {
        id
      }
      member {
        id
        memberId
      }
      text {
        message

        isImage
      }
      createdAt
    }
  }
`;

export const CREATE_MESSAGE_NOTIFICATION = gql`
  mutation createChatNotification($input: ChatNotificationInput!) {
    createChatNotification(input: $input) {
      id
      isRead
      member {
        id
      }
      message {
        id
        chatRoom {
          id
        }
      }
    }
  }
`;

export const DELETE_MESSAGE = gql`
  mutation deleteMessage($id: ID!) {
    deleteMessage(id: $id) {
      ...messageInfo
    }
  }
  ${MESSAGE_INFO}
`;

export const READ_MESSAGE = gql`
  mutation readMessage($chatRoomId: ID!) {
    readMessage(chatRoomId: $chatRoomId) {
      ...messageInfo
    }
  }
  ${MESSAGE_INFO}
`;
